"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M20 15V20H4L4 4H9", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" }),
    react_1.default.createElement("path", { d: "M11 13L20 4M20 4V12M20 4H12", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" })));
